/* eslint-disable import/no-anonymous-default-export */

let masterData = {
  name: "Master Data",
  slug: "masterData",
  singularName: "MasterData",
  crud: true,
  uploadPage: true,
  updateLabel: "Master Data",
  filters: [],
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  update: true,
  edit: false,
  actions: [],
  fields: [],
};

export default [masterData];
